import React from "react";
import { Typography } from "antd";
import { CONTACT_CONTENT } from "../../../../constants/content/pages/contact";

import "./styles.scss";

const { Text } = Typography;

const Address = () => {
  return (
    <div className="Address">
      <Text className="Address-address">
        {CONTACT_CONTENT.contactInfo.address}
      </Text>
      <Text className="Address-email">{CONTACT_CONTENT.contactInfo.email}</Text>
    </div>
  );
};

export default Address;
